// File: frontend/src/pages/StudentPaymentsPage.jsx

import React, { useState, useEffect } from 'react';
import { studentPortalAPI } from '../services/api';
import Spinner from '../components/Spinner';
import toast from 'react-hot-toast';

const methodLabel = (m) => m === 'cash' ? '💵 Cash' : m === 'line_pay' ? '🟢 LINE Pay' : '🏦 Bank Transfer';

export default function StudentPaymentsPage() {
    const [payments, setPayments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        studentPortalAPI.getMyPayments()
            .then(setPayments)
            .catch(() => toast.error('Could not load payment history.'))
            .finally(() => setIsLoading(false));
    }, []);

    if (isLoading) return <Spinner />;

    const totalPaid = payments.filter(p => p.status === 'paid').reduce((sum, p) => sum + parseFloat(p.amount), 0);
    const totalPending = payments.filter(p => p.status === 'pending').reduce((sum, p) => sum + parseFloat(p.amount), 0);

    return (
        <div>
            <h2 className="text-2xl font-bold mb-4">My Payment History</h2>
            <div className="grid grid-cols-2 gap-3 mb-4">
                <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
                    <h3 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Total Paid</h3>
                    <p className="text-2xl font-bold text-emerald-600 mt-1">NT${totalPaid.toLocaleString()}</p>
                </div>
                <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
                    <h3 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Pending</h3>
                    <p className="text-2xl font-bold text-amber-600 mt-1">NT${totalPending.toLocaleString()}</p>
                </div>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 divide-y divide-gray-100 dark:divide-gray-700">
                {payments.length > 0 ? payments.map(p => (
                    <div key={p.id} className="p-4 flex justify-between items-center">
                        <div>
                            <p className="font-semibold text-gray-900 dark:text-gray-100">{p.class_name}</p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">{new Date(p.fee_date).toLocaleDateString()} • {methodLabel(p.payment_method)}</p>
                        </div>
                        <div className="text-right">
                            <p className="font-bold text-gray-900 dark:text-gray-100">NT${parseFloat(p.amount).toLocaleString()}</p>
                            <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${
                                p.status === 'paid' ? 'bg-emerald-100 text-emerald-800'
                                : p.status === 'waived' ? 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
                                : 'bg-amber-100 text-amber-800'
                            }`}>
                                {p.status === 'paid' ? '✓ Paid' : p.status === 'waived' ? 'Waived' : 'Pending'}
                            </span>
                        </div>
                    </div>
                )) : <p className="p-6 text-center text-gray-500 dark:text-gray-400">No payment records yet.</p>}
            </div>
        </div>
    );
}
